<template>
  <div class="header-container">
    <div id="sticky-risk" :class="{ ar: languageSelActive == 'ar' }">
      <p v-if="expandRisk" v-html="$t('topFixedBanner')"></p>
      <div v-else class="mob_risk">
        <strong>{{ $t("topFixedBannerShort") }}</strong>
      </div>
      <div class="arrow" @click="toggleRisk()">
        <i v-if="expandRisk" class="fas el-icon-arrow-down"></i>
        <i v-else class="fas el-icon-arrow-up"></i>
      </div>
    </div>
    <div class="header-top">
      <span class="FCANO">{{ $t("FCA_License_No") }}: 760555</span>
      <span class="select-language" @click="showMenus($event)">
        <span class="menu-span-text">
          <!-- <img :src="languageSelActiveImg" style="width:24px;height:14px;margin-right:10px;" alt="" /> -->
          <span style="display: inline-block;width: 30px;height: 30px;text-align: center;line-height: 39px;float: left;margin-right: 1px;">
            <img src="../assets/images/earth.png" style="width: 20px; height: 18px" alt="" />
          </span>
          <span style="display: inline-block;height: 33px;text-align: center;line-height: 30px;float: left;font-size: 13px;">
            {{ languageSelList[languageSelActiveImg] }}
          </span>
          <i :class="{'el-icon-caret-bottom': !hideLiStyle,'el-icon-caret-top': hideLiStyle}" />
        </span>
        <ul class="menu-ul" :class="{ hide_liStyle: !hideLiStyle, show_liStyle: hideLiStyle }">
          <li v-for="(item, index) in temps" :key="index" @click="selectLanguage(item)" class="menu-li">
            <!-- <img :src="item.imgUrl" style="width:24px;height:14px;margin-right:10px;" alt="" />{{languageSelList[item.id]}} -->
            {{ languageSelList[item.id] }}
          </li>
        </ul>
      </span>
    </div>
    <a :href="languageSelActiveHref" class="logo-header">
      <img src="../assets/images/newlong.jpg" class="logo logo_phone" style="width: 90%; height: 3rem; padding: 1rem" />
      <div style="padding: 0; width: 361px">
        <img src="../assets/images/newlong.jpg" class="logo logo_pc" style="width: 100%; height: 40px; padding: 1rem 0" />
      </div>
    </a>
    <div class="model-box" v-if="showTipModel">
      <div class="model policyBar">
        <div :class="['model-header', { 'model-header-mini': screenWidth < 992 }]">
          Tips:
        </div>
        <div class="model-content tips-text">
          <p v-html="$t('policyBarClose')"></p>
          <p v-html="$t('policyBar')"></p>
        </div>
        <div class="model-btns">
          <el-button size="medium" @click="policyBarDown()">{{$t("policyBarButton")}}</el-button>
        </div>
      </div>
    </div>
    <div class="model-box" v-if="showModel">
      <div class="model">
        <div :class="['model-header', { 'model-header-mini': screenWidth < 992 }]">
          Please choose your preferred language
        </div>
        <div class="model-content">
          <template v-for="(item, index) in banners" class="newbanner">
            <p class="choose-lang" @click="externalLans = item.id">
              {{ item.name }}
            </p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import $ from "jquery";
export default {
  inject: ["reload"],
  data() {
    return {
      screenWidth: document.body.clientWidth,
      showTipModel: true,
      showModel: false,
      externalLan: "en",
      externalLans: "",
      // languageSelActive: localStorage.language || "en",
      languageSelActive: Cookies.get("language") || "en",
      languageSelActiveImg: "",
      hideLiStyle: false,
      temps: [
        {
          imgUrl: require("../assets/select-img/cn.png"),
          id: "cn",
        },
        {
          imgUrl: require("../assets/select-img/hk.png"),
          id: "hk",
        },
        {
          imgUrl: require("../assets/select-img/en.png"),
          id: "en",
        },
        {
          imgUrl: require("../assets/select-img/ar.png"),
          id: "ar",
        },
        // {
        //   imgUrl: require("../assets/select-img/hi.png"),
        //   id: "hi"
        // },
        // {
        //   imgUrl: require("../assets/select-img/ur.png"),
        //   id: "ur"
        // },
        {
          imgUrl: require("../assets/select-img/es.png"),
          id: "es",
        },
        {
          imgUrl: require("../assets/select-img/it.png"),
          id: "it",
        },
        {
          imgUrl: require("../assets/select-img/de.png"),
          id: "de",
        },
        {
          imgUrl: require("../assets/select-img/pt.png"),
          id: "pt",
        },
      ],
      banners: [
        {
          imgUrl: require("../assets/images/banner/English.png"),
          imgUrlSmall: require("../assets/select-img/en.png"),
          id: "en",
          name: "English",
        },
        {
          imgUrl: require("../assets/images/banner/Deutsch.png"),
          imgUrlSmall: require("../assets/select-img/de.png"),
          id: "de",
          name: "Deutsch",
        },
        {
          imgUrl: require("../assets/images/banner/espanol.png"),
          imgUrlSmall: require("../assets/select-img/es.png"),
          id: "es",
          name: "Español",
        },
        {
          imgUrl: require("../assets/images/banner/Italiano.png"),
          imgUrlSmall: require("../assets/select-img/it.png"),
          id: "it",
          name: "Italiano",
        },
        {
          imgUrl: require("../assets/images/banner/Portugal.png"),
          imgUrlSmall: require("../assets/select-img/pt.png"),
          id: "pt",
          name: "Português",
        },
        {
          imgUrl: require("../assets/images/banner/China.png"),
          imgUrlSmall: require("../assets/select-img/cn.png"),
          id: "cn",
          name: "中文(简体)",
        },
        {
          imgUrl: require("../assets/images/banner/China.png"),
          imgUrlSmall: require("../assets/select-img/hk.png"),
          id: "hk",
          name: "中文(繁體)",
        },
      ],
      language_choose: {
        ar: 6,
        en: 1,
        es: 3,
        cn: 7,
        pt: 4,
        it: 2,
        de: 5,
        hk: 0,
      },
      liveChatLanguageList: {
        ar: "ARABIC",
        en: "ENGLISH",
        es: "SPANISH",
        cn: "TRADITIONAL_CHINESE",
        pt: "PORTUGUESE",
        it: "ITALIAN",
        de: "GERMAN",
        hk: "TRADITIONAL_CHINESE",
      },
      language: Cookies.get("language"),
      languageSelActiveHref: this.$t("logoLink"),
      expandRisk: true, //展开风险警告
    };
  },
  computed: {
    ...mapState(["LANGUAGE"]),
    languageSelList() {
      // 语言列表
      return {
        en: "English",
        cn: "中文(简体)",
        hk: "中文(繁體)",
        ar: "عربى",
        hi: "हिन्दी",
        ur: "اردو",
        it: "Italiano",
        es: "Español",
        de: "Deutsch",
        pt: "Português",
      };
    },
  },
  watch: {
    externalLans(val, old) {
      // console.log("val:"+val,"old:"+old)
      this.externalLan = this.externalLans;
      this.SelexternalLan();
    },
  },
  mounted() {
    if (this.$route.query.lang) {
      // if (this.$route.query.lang == 'zh-hant') {
      //   this.languageSelActive = 'hk';
      //   this.$i18n.locale = 'hk';
      // } else if (this.$route.query.lang == 'zh') {
      //   this.languageSelActive = 'cn';
      //   this.$i18n.locale = 'cn';
      // } else if (this.$route.query.lang == 'zh-EN') {
      //   this.languageSelActive = 'en';
      //   this.$i18n.locale = 'en';
      // } else {
      //   this.languageSelActive = this.$route.query.lang;
      //   this.$i18n.locale = this.$route.query.lang;
      // }
      this.showModel = true;
      this.showTipModel = false;
    }
    //增加livechat 聊天会话框 除中国区域外
    if (this.language != "cn") {
      this.createChat(this.language);
    }

    this.temps.find((item) => {
      if (item.id == this.languageSelActive)
        // return (this.languageSelActiveImg = item.imgUrl);
        return (this.languageSelActiveImg = item.id);
    });
    var that = this;
    $(document).on("click", (e) => {
      if (that.hideLiStyle) {
        that.hideLiStyle = false;
      }
    });
  },
  methods: {
    policyBarDown() {
      this.showTipModel = false;
    },
    SelexternalLan() {
      this.languageSelActive = this.externalLan;
      this.hideLiStyle = true;
      this.$i18n.locale = this.externalLan;
      Cookies.set("language", this.externalLan);
      this.$store.commit("SAVELANGUAGE", this.externalLan);
      var routeFullPath = this.$route.fullPath;
      console.log("routeFullPath===", routeFullPath);
      if (this.$route.query.lang) {
        var routeLang = this.$route.query.lang;
        var replaceLang =
          routeFullPath.indexOf("lang=" + routeLang + "&") > -1
            ? "lang=" + routeLang + "&"
            : "lang=" + routeLang;
        console.log("replaceLang===", replaceLang);
        routeFullPath = routeFullPath.replace(replaceLang, "");
      }
      console.log("routeFullPath===", routeFullPath);
      // if(this.$route.query.a) this.$router.push('/?a='+this.$route.query.a)
      // else this.$router.push('/')
      if (routeFullPath) this.$router.push(routeFullPath);
      else this.$router.push("/");
      setTimeout(() => {
        this.showTipModel = false;
        this.reload();
      }, 50);
    },
    showMenus(e) {
      e.stopPropagation();
      this.hideLiStyle = !this.hideLiStyle;
    },
    selectLanguage(item) {
      if (item.id == Cookies.get("language")) return;
      this.$confirm(
        this.$t("messages.fieldsWillBeReset"),
        this.$t("ModalMsg.showAlert.title"),
        {
          confirmButtonText: this.$t("ModalMsg.showAlert.submitBtnTxt"),
          cancelButtonText: this.$t("ModalMsg.showAlert.cancleBtnTxt"),
          type: "warning",
        }
      )
        .then(() => {
          this.languageSelActive = item.id;
          this.languageSelActiveImg = item.imgUrl;
          this.hideLiStyle = true;
          this.$i18n.locale = item.id;
          Cookies.set("language", item.id);
          this.language = Cookies.get("language");
          this.$store.commit("SAVELANGUAGE", item.id);
          this.reload();
          //刷新更改livechat语言
          if ($("#chat-widget-container").length > 0) {
            //作用 使界面看起来不卡顿
            $("#chat-widget-container").css("display", "none");
          }
          window.LC_API.minimize_chat_window();
          location.reload(true);
        })
        .catch(() => {});
    },
    createChat(language) {
      language = language != "" && language != undefined ? language : "en";
      let liveChatLanguage = this.liveChatLanguageList[language];
      liveChatLanguage = liveChatLanguage != "" && liveChatLanguage != undefined ? liveChatLanguage : "ENGLISH";
      console.log("liveChatLanguage", liveChatLanguage);
      
      let entity   = "UK";
      let UK_CHANNEL_MAPPING = {
        "SIMPLIFIED_CHINESE" : {
          "LIVECHAT_00D7F000001ZtT8UAK" : {
            "id"        : "LIVECHAT",
            "label"     : "在线聊天",
            "icon"      : "default"
          }
        },
        "TRADITIONAL_CHINESE" : {
          "LIVECHAT_00D7F000001ZtT8UAK" : {
            "id"        : "LIVECHAT",
            "label"     : "在線聊天",
            "icon"      : "default"
          }
        },
        "ENGLISH" : {
          "LIVECHAT_00D7F000001ZtT8UAK" : {
            "id"        : "LIVECHAT",
            "label"     : "Live Chat",
            "icon"      : "default"
          }
        },
        "SPANISH" : {
          "LIVECHAT_00D7F000001ZtT8UAK" : {
            "id"        : "LIVECHAT",
            "label"     : "Chat en vivo",
            "icon"      : "default"
          }
        },
        "PORTUGUESE" : {
          "LIVECHAT_00D7F000001ZtT8UAK" : {
            "id"        : "LIVECHAT",
            "label"     : "Chat em tempo real",
            "icon"      : "default"
          }
        },
        "GERMAN" : {
          "LIVECHAT_00D7F000001ZtT8UAK" : {
            "id"        : "LIVECHAT",
            "label"     : "Live-Chat",
            "icon"      : "default"
          }
        },
        "ITALIAN" : {
          "LIVECHAT_00D7F000001ZtT8UAK" : {
            "id"        : "LIVECHAT",
            "label"     : "Chat dal vivo",
            "icon"      : "default"
          }
        },
        "ARABIC" : {
          "LIVECHAT_00D7F000001ZtT8UAK" : {
            "id"        : "LIVECHAT",
            "label"     : "الدردشة الحية",
            "icon"      : "default"
          }
        },
      }
      let channelMap = {};
      let customChannelMap;
      if(entity == "UK") {
        if(UK_CHANNEL_MAPPING[liveChatLanguage]) {
          channelMap = UK_CHANNEL_MAPPING[liveChatLanguage];
        } else { 
          channelMap = UK_CHANNEL_MAPPING[liveChatLanguage];
        }
      }
      RecurLivechat.init({
        "liveChat" : {
          "id"               : "lXTZKqXwLP9CWhJtLqQcbSrHXPrhT35Dm0bRGWc0n4LxXcEVAY1enrOhjmcSoMEW",
          "secret"           : "iYtd7FBtYkBURBiF4z59rl4ViAHWvQMp9IZL3R2jH7Zux4ND9KIN8XGYw89WOw0x",
          "serverUrl"        : "https://prod.api.recur-omni.io",
          "websocketUrl"     : "wss://websocket.recur-omni.io/prod",
          "isEnableLiveChat" : true,
          "showPrechatForm"  : true,
          "isEnableFeedback" : true,
          "feedbackOptions"  : ["Normal", "Like", "Very Like"],
          "language"         : liveChatLanguage
        },
        "actionButton" : {
          "iconColor"       : "#ffffff",
          "hoverIconColor"  : "#c6c6c6",
          "primaryColor"    : "#000000",
          "buttonIconColor" : "#000000",
          "buttonColor"     : ["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"]
        },
        "popupPanel" : {
          "headerTextColor"       : "#ffffff",
          "headerBackgroundColor" : "#00A6FB"
        },
        "mainPanel" : {
          "headertextColor"             : "#ffffff",
          "headerBackgroundColor"       : "#000000",
          "headerButtonBackgroundColor" : "#000000",
          "confirmButtonColorStyle"     : "border",
          "confirmButtonColor"          : "#000000",
          "confirmButtonTextColor"      : "#000000",
          "cancelButtonColor"           : "#ff0000",
          "cancelButtonTextColor"       : "#ff0000",
          "buttonIconBackgroundColor"   : "#000000",
          "buttonIconColor"             : "#ffffff"
        },
        "channelMap"       : channelMap,
        "customChannelMap" : customChannelMap,
        "params" : {
          "Entity__c" : entity
        },
        "prechatDefaultValue" : {
          "Entity__c" : entity,
          "Recur_Omni__Language__c" : liveChatLanguage
        }
      });
    },
    toggleRisk() {
      this.expandRisk = !this.expandRisk;
      setTimeout(() => {
        this.$emit("getPaddingTop");
      }, 0);
    },
  },
};
</script>

<style lang="scss">
@media only screen and (max-width: 768px) {
  .el-message-box__wrapper {
    left: 10px;
    right: 10px;
    .el-message-box {
      width: 80% !important;
    }
  }
}
.mobileType {
  .header-container {
    .FCANO {
      font-size: 12px;
      font-family: "Muli", "Helvetica Neue", Arial, sans-serif;
    }
    .select-language {
      width: 100%;

      .menu-span-text {
        display: inline-block;
        max-width: 150px;
      }

      .menu-ul {
        width: 100%;
      }
    }
    .logo_phone {
      display: block;
      margin: 0 auto;
    }
    .logo_pc {
      display: none;
    }
  }
}

.pcType {
  .header-container {
    .menu-ul {
      width: 121px;
      padding-left: 0;
      li {
        padding-left: 20px;
      }
    }
    .logo_phone {
      display: none;
    }
    .logo_pc {
      margin-left: 20px;
      display: block;
    }
  }
}

.header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  // z-index:9999;
  z-index: 2000;
  .header-top {
    background: #23282c;
    color: #fff;
    line-height: 30px;
    height: 30px;
    padding: 0 20px;
    border-top: solid 4px #f2672a;

    .FCANO {
      position: fixed;
    }

    .select-language {
      float: right;
      text-align: right;
      position: relative;
      .menu-span-text,
      .menu-ul li {
        cursor: pointer;
      }

      .menu-span-text {
        display: inline-block;
        max-width: 150px;
      }
      .menu-ul {
        background: #23282c;
        position: absolute;
        right: -20px;
        top: 14px;
        z-index: 999;
        li {
          text-align: left;
          &:hover {
            background: #999;
          }
        }
      }
    }

    .hide_liStyle {
      display: none;
    }

    .show_liStyle {
      display: block;
    }
  }

  .logo-header {
    width: 100%;
    display: block;
    text-align: center;
    border-bottom: 1px solid #333;
    box-shadow: 0 0 3px #333;
    background: #fff;
  }
}
.model-box {
  direction: ltr;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  .model {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    /*background: url('../assets/images/banner/map-03.png') no-repeat center center;*/
    background-color: #e5e5e5;
    border-radius: 4px;
    /*  border: 1px solid #ebeef5;*/
    font-size: 18px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: center;
    .model-header {
      position: relative;
      background: #000;
      color: #fff;
      // padding-bottom: 30px;
      font-weight: 700;
      line-height: 45px;
      padding-left: 20px;
      padding-right: 20px;
    }

    .model-header-mini {
      line-height: 30px;
    }
    .m-model-header {
      padding-left: 10px;
      padding-right: 10px;
    }
    .model-content {
      // padding: 20px;
      .banner {
        display: inline-block;
        width: 20%;
        margin: 5px 20px;
        > img {
          width: 120px;
          border-radius: 4px;
        }
        p {
          margin: 5px 0;
        }
      }
      .newbanner {
        text-align: left;
        padding-left: 38%;
      }
      .el-radio__inner {
        border: 1px solid #606266;
      }
      .m-banner {
        text-align: left;
        margin-bottom: 10px;
      }

      .mar-center {
        text-align: center !important;
        display: inline-block;
      }
      p.choose-lang {
        padding: 0px;
        margin: 0px;
        height: 34px;
        line-height: 34px;
        cursor: pointer;
      }

      p.choose-lang:hover {
        background: #ff7f27;
      }

      p.choose-lang:active {
        background: #ff7f27;
      }
    }
    .model-btns {
      // margin-top: 30px;
      padding-bottom: 30px;
    }
    .tips-text p {
      text-align: left;
    }
  }
}
.policyBar a {
  color: #000;
}
.policyBar a:hover {
  color: #f1672a;
}
.policyBar p {
  padding: 10px;
}
#sticky-risk {
  padding: 0;
}
#sticky-risk {
  position: relative;
  min-width: 100%;
  height: auto;
  padding: 0;
  font-size: 13px;
  line-height: 18px;
  // color: #24282d;
  // background-color: #f5f5f5;
  color: white;
  background-color: black;
  text-align: center;
  z-index: 100000;
  padding: 11px 30px;
}
#sticky-risk {
  position: relative;
  min-width: 100%;
  height: auto;
  padding: 0;
  font-size: 13px;
  line-height: 18px;
  color: white;
  background-color: black;
  text-align: center;
  z-index: 100000;
  font-family: "muli";
}
#sticky-risk p {
  // color: #24282d !important;
  color: white !important;
  font-size: 16px;
  line-height: 19px;
  max-width: 1140px;
  margin: 0 auto;
}
#sticky-risk p {
  color: white !important;
  font-size: 16px;
  line-height: 19px;
  max-width: 1170px;
  margin: 0 auto;
  padding: 11px 30px;
}
.fa,
.fas {
  font-weight: 900;
}
.fa,
.far,
.fas {
  font-family: "Font Awesome 5 Free";
}
.fa,
.fab,
.fad,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
#sticky-risk .arrow {
  display: none;
}
.ar {
  text-align: right;
  direction: rtl;
}
@media (max-width: 992px) {
  #sticky-risk .arrow {
    position: absolute;
    right: 10px;
    top: 10px;
    display: block;
    cursor: pointer;
  }
  #sticky-risk .arrow {
    position: absolute;
    right: 10px;
    top: 10px;
    display: block;
  }
  .model-box {
    .model {
      width: 80%;
    }
  }
}

@media (max-width: 767px) {
  #sticky-risk p,
  .mob_risk {
    padding: 10px 55px 10px 30px;
    text-align: left;
  }
  #sticky-risk p,
  .mob_risk {
    padding: 10px 55px 10px 30px;
    text-align: left;
  }
  .model-box {
    .model {
      width: 97%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue